import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@22.15.21_better-sqlite3@11.10.0_db0@0.3.2_bette_jp3kux5oyy2rrhzsnr62nzmtpy/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/app/router.options.ts";
const configRouterOptions = {
  linkActiveClass: "route-active",
  linkExactActiveClass: "route-active-exact",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}